import { Icon } from "@iconify/react";
import React from "react";

const LookupsFilter = ({ text, onChange }) => {
  return (
    <>
      <form
        className="filterTemplate mb-0"
        onSubmit={(e) => e.preventDefault()}
      >
        <div className="relative ">
          <input
            type="text"
            value={text}
            onChange={(e) => onChange(e.target.value)}
            className="form-control"
            placeholder="Search"
          />
          <i>
            <Icon icon="ep:search" />
          </i>
        </div>
      </form>
    </>
  );
};

export default LookupsFilter;
